import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { getBuildCommit, getNodeTestProps } from '@/utils';

type BuildCommitProps = {
    className?: string;
};

/**
 * The bundle's build commit in small muted text, so the operator can match
 * this front end to the API's health commit. Shown on the enroll and seller
 * sign-in screens and in the admin sidebar footer.
 */
export const BuildCommit: React.FC<BuildCommitProps> = ({ className }) => {
    const { t } = useTranslation('components');

    return (
        <Typography
            className={className}
            color="muted"
            type="body-xs"
            {...getNodeTestProps('build-commit')}
        >
            {t('build.commit', { commit: getBuildCommit() })}
        </Typography>
    );
};
